import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RubenConnect from "@/pages/lp/RubenConnect";

export const Route = createFileRoute("/lp/ruben")({
  head: () => seoHead("/lp/ruben"),
  component: RubenConnect,
});
